import { Component } from 'react'
import { ENTER } from './keys'
import LocaleUtils from './LocaleUtils'

export default class Caption extends Component {
  static defaultProps = {
    localeUtils: LocaleUtils,
  }

  constructor(props) {
    super(props)
    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  shouldComponentUpdate(nextProps) {
    return (
      nextProps.locale !== this.props.locale ||
      nextProps.classNames !== this.props.classNames ||
      nextProps.date.getMonth() !== this.props.date.getMonth() ||
      nextProps.date.getFullYear() !== this.props.date.getFullYear()
    )
  }

  handleKeyUp(e) {
    if (e.keyCode === ENTER) {
      this.props.onClick(e)
    }
  }

  render() {
    const { classNames, date, months, locale, localeUtils, onClick } = this.props
    return (
      // biome-ignore lint/a11y/useSemanticElements: TODO
      // biome-ignore lint/a11y/useAriaPropsForRole: TODO
      <div className={classNames.caption} role="heading">
        {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
        <div onClick={onClick} onKeyUp={this.handleKeyUp}>
          {months ? `${months[date.getMonth()]} ${date.getFullYear()}` : localeUtils.formatMonthTitle(date, locale)}
        </div>
      </div>
    )
  }
}
